import { WholePageError } from '@/components/WholePageError';
import { NEW_INTERACTION_ERRORS } from '@/views/NewInteraction/staticText';
import type { ErrorMessage } from '@/views/NewInteraction/types';

interface Props {
  errorMessage: ErrorMessage;
}

export const ErrorPage = ({ errorMessage }: Props) => {
  if (!errorMessage) return null;

  return (
    <WholePageError
      svg={NEW_INTERACTION_ERRORS[errorMessage].svg}
      title={NEW_INTERACTION_ERRORS[errorMessage].title}
      sx={{ marginTop: { xs: 5 }, backgroundColor: 'transparent' }}
    />
  );
};
